import React from 'react'
import { useLocation } from 'react-router-dom'
import { SignIn, ClerkLoaded, ClerkLoading } from '@clerk/react'
import { Box, Typography, CircularProgress } from '@mui/material'

export default function LoginPage() {
  const { state } = useLocation()
  const from = state?.from
  const redirect = from?.pathname?.startsWith('/notifications/')
    ? `${from.pathname}${from.search || ''}`
    : '/dashboard'
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f8fafc',
        py: 3,
      }}
    >
      <ClerkLoading>
        <Box sx={{ textAlign: 'center', px: 2 }}>
          <CircularProgress sx={{ color: '#1a365d' }} />
          <Typography sx={{ mt: 2, color: '#475569' }}>Loading sign-in…</Typography>
        </Box>
      </ClerkLoading>
      <ClerkLoaded>
        <SignIn
          routing="hash"
          signUpUrl="/signup"
          forceRedirectUrl={redirect}
        />
      </ClerkLoaded>
    </Box>
  )
}
